export default __webpack_public_path__ + "static/media/renew.9c55b139.svg";